  //////////////////////////////////////////////////////////////////////
//
//  09/26/18
//  src/containers/MainMap.js
//
//  This file is the top level MainMap javascript file.
//

import React, { Component } from 'react';
import { IRH_myModal } from "../components/IconRowHelp";
import MapPage   from "../components/MapPage";
import BarData   from "../components/BarData";
import RestData  from "../components/RestData";
import MusicData from "../components/MusicData";
import GrillData from "../components/GrillData";
import mapImg    from "../images/Map.png";
import './MainMap.css';

class MainMap extends Component {
  render() {
    const { navbar } = this.props;
    const bIdx = 10;
    console.log( "MainMap Props.navbar.sCat: " + navbar.sCat );

    var title = "";
    var xdata = {};

    switch( navbar.sCat ) {
    case 'bars':   xdata = this.formatData( BarData,   bIdx );    title="Bars";               break;
    case 'rests':  xdata = this.formatData( RestData,  bIdx );    title="Restaurants";        break;
    case 'music':  xdata = this.formatData( MusicData, bIdx );    title="Music";              break;
    default:       xdata = this.formatData( GrillData, bIdx );    title="Bar and Grills";     break;
    }

    return (
      <div id="MainMapTop">
        <div id="MainMapTitle">{ title }</div>
        <div id="MainMapBody">
          <div id="MainMapData">{ xdata }</div>
          <div id="MainMapImg">
            <img id="MainMImg" src={ mapImg } alt="Map of local businesses." width="100%" />
          </div>
        </div>

        <div id={ 'myModal' }  style={ IRH_myModal }>
        </div>

      </div> 
    );
  }

  //
  //  Format the data to layout on the screen
  //
  formatData( cData, rNum ) {
    var tmpData = cData.map( ( val, idx ) => {
      //console.log( "Index: " + ( idx + bIdx ) + ", Name: " + val.name ); 
        return( 
          <MapPage 
            key = { idx } 
            miles={ val.miles } 
            name ={ val.name  } 
            row  ={ idx+rNum  } 
            music={ val.music }
            food ={ val.food  }
            happy={ val.happy }
            notes={ val.notes }
            mpop ={ val.mpop  }
            fpop ={ val.fpop  }
            hpop ={ val.hpop  }
            addr ={ val.addr  }
          />
        );
      });
    return tmpData;
  }
}

export default MainMap;



// WEBPACK FOOTER //
// ./src/containers/MainMap.js